export interface GetSurveyRequest {
  context: SurveyName;
  productName: string,
  expiryDate: string;
}

export interface SurveyConfig {
  id: SurveyName;
  surveyURL: string;
  dialogWidth?: number;
  dialogHeight?: number;
}

export enum SurveyName {
  TURN_OFF_AUTO_RENEW_SURVEY = 'turnOffAutoRenewalCE',
}
